import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import {
  BANNER_ASPECT_RATIO,
  BORDERS,
  COLOR,
  FIXED_INDENTS,
  MEDIA,
} from 'vars/index'

/**
 * The circular state marker the content details concept drops on the banner
 * when the content is PIN-locked or geoblocked.
 *
 * The concept centres it on the artwork, which only works where the artwork has
 * room the banner-description does not claim. Under 600 the shell is portrait
 * and the description sits at its foot, so the badge is centred near the top
 * edge as drawn. Compact home and details banners (600–1023) raise a 580px
 * floor under a 16:9 artwork band, so the badge centres on that band.
 * Percentage margins resolve against width: 50% / 16:9-ratio is the artwork's
 * vertical centre. From 1024 the compact floor is 0 and the shell is 16:9, so
 * Figma moves the badge to the free right-hand side.
 */
export const ContentStateBadgeSC = styled.div`
  --contentStateBadgeSize: var(${FIXED_INDENTS.INDENT_240});
  --contentStateBadgeIconSize: var(${FIXED_INDENTS.INDENT_140});

  position: absolute;
  top: var(${FIXED_INDENTS.INDENT_200});
  left: 50%;
  z-index: 1;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: var(--contentStateBadgeSize);
  height: var(--contentStateBadgeSize);
  padding: var(${FIXED_INDENTS.INDENT_50});
  border: var(${BORDERS.BORDER_10}) solid var(${COLOR.SURFACE_OPACITY_LIGHT_15});
  border-radius: 50%;
  transform: translateX(-50%);
  background: var(${COLOR.SURFACE_OPACITY_DARK_25});

  ${IconSC} {
    width: var(--contentStateBadgeIconSize);
    height: var(--contentStateBadgeIconSize);
  }

  ${MEDIA.MIN_600} {
    top: 0;
    right: auto;
    left: 50%;
    margin-top: calc(50% / var(${BANNER_ASPECT_RATIO.SIZE_50}));
    transform: translate(-50%, -50%);
  }

  ${MEDIA.MIN_1024} {
    --contentStateBadgeSize: var(${FIXED_INDENTS.INDENT_390});
    --contentStateBadgeIconSize: var(${FIXED_INDENTS.INDENT_230});

    top: 50%;
    right: var(${FIXED_INDENTS.INDENT_300});
    left: auto;
    margin-top: 0;
    transform: translateY(-50%);
  }

  ${MEDIA.MIN_1240} {
    /* 200px in the concept; no fixed-indent token reaches that far. */
    right: calc(
      var(${FIXED_INDENTS.INDENT_400}) + var(${FIXED_INDENTS.INDENT_100})
    );
  }
`
